'use client'

import { TrendingUp } from 'lucide-react'
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/shadcn/card'
import { Badge } from '@/components/ui/shadcn/badge'

export default function KeyMetric({ title, value, subtitle, trend, onClick }) {
  return (
    <Card
      className={
        onClick
          ? 'cursor-pointer transition-colors hover:bg-accent/50'
          : undefined
      }
      onClick={onClick}
    >
      <CardHeader>
        <CardDescription>{title}</CardDescription>
        <CardTitle className="text-2xl font-semibold tabular-nums">
          {value}
        </CardTitle>
        {subtitle && (
          <p className="text-xs text-muted-foreground">{subtitle}</p>
        )}
      </CardHeader>
      {trend && (
        <CardFooter>
          <Badge
            variant="outline"
            className="flex max-w-full gap-1 rounded-lg text-xs whitespace-normal break-words"
          >
            <TrendingUp className="size-3 shrink-0" />
            <span className="min-w-0">{trend}</span>
          </Badge>
        </CardFooter>
      )}
    </Card>
  )
}
